const vP18322 = require("./121.js");
const vA794 = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", " ", "$", "%", "*", "+", "-", ".", "/", ":"];
function f2186(p18323) {
  this.mode = vP18322.ALPHANUMERIC;
  this.data = p18323;
}
f2186.getBitsLength = function (p18324) {
  return Math.floor(p18324 / 2) * 11 + p18324 % 2 * 6;
};
f2186.prototype.getLength = function () {
  return this.data.length;
};
f2186.prototype.getBitsLength = function () {
  return f2186.getBitsLength(this.data.length);
};
f2186.prototype.write = function (p18325) {
  let v14074;
  for (v14074 = 0; v14074 + 2 <= this.data.length; v14074 += 2) {
    let v14075 = vA794.indexOf(this.data[v14074]) * 45;
    v14075 += vA794.indexOf(this.data[v14074 + 1]);
    p18325.put(v14075, 11);
  }
  if (this.data.length % 2) {
    p18325.put(vA794.indexOf(this.data[v14074]), 6);
  }
};
module.exports = f2186;